import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { type EmblaOptionsType } from 'embla-carousel'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'

export class TextCarousel extends UcoastEl {
	static htmlSelector = 'text-carousel'
	initialCount: number
	navButtons: NodeListOf<HTMLButtonElement>
	mediaItems: NodeListOf<HTMLElement>
	constructor() {
		super()
		this.loadSlidesInView = this.loadSlidesInView.bind(this)
		this.initialCount = parseInt(q.ra(this, 'data-initial-count'))
		this.navButtons = q.rl('[data-slide-index]', this)
		this.mediaItems = q.rl('[data-media-index]', this)
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	initializeSlider() {
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'center',
			containScroll: 'keepSnaps',
			dragFree: false,
			duration: 20,
			dragThreshold: 20,
			loop: true,
			startIndex: this.initialCount,
		}

		const viewportNode = q.rs('[data-viewport]', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		emblaApi.on('init', () => {
			window.setTimeout(() => {
				this.loadSlidesInView()
				this.pauseSlidesOutsideView()
			}, 100)
		})
		emblaApi.on('slidesInView', () => {
			this.loadSlidesInView()
			this.pauseSlidesOutsideView()
		})
		emblaApi.on('select', () => {
			const index = emblaApi.selectedScrollSnap()
			const currentSlide = emblaApi.slideNodes()[index]
			console.log({ index, currentSlide })
			const button = q.rs('[data-slide-index]', currentSlide)
			const mediaIndex = parseInt(q.ra(button, 'data-slide-index'))
			this.activateMedia(mediaIndex)
		})
		this.navButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const index = parseInt(q.ra(button, 'data-slide-index'))
				const page = parseInt(q.ra(button, 'data-page-index'))
				emblaApi.scrollTo(index + page * this.initialCount)
				this.activateMedia(index)
			})
		})
	}

	activateMedia(index: number) {
		const currentMedia = Array.from(this.mediaItems).find(
			(el) => el.getAttribute('data-media-index') === index.toString()
		)
		if (!currentMedia) {
			throw new Error(`No media item found for index ${index}`)
		}
		if (currentMedia.getAttribute('aria-hidden') === 'false') return
		const activeMedia = q.rs('[data-media-index][aria-hidden="false"]', this)
		activeMedia.setAttribute('aria-hidden', 'true')
		currentMedia.setAttribute('aria-hidden', 'false')

	}

	loadSlidesInView() {
		q.ol('.is-in-view', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.playAllInContainer(slide)
		})
	}
	pauseSlidesOutsideView() {
		q.ol('[data-embla-slide]:not(.is-in-view)', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.pauseAllInContainer(slide)
		})
	}
}
